<template src="./module_form.html"></template>

<script>
import { CreateModule } from '@/api/auth'

export default {
  name: 'add-module',
  data: function () {
    return {
      model: {
        app_id: null,
        item: '',
        note: ''
      },
      ruleValidate: {
        item: [{
          required: true,
          message: '必须填写模块名称',
          trigger: 'blur'
        }],
        note: [{
          required: true,
          message: '模块描述或备注不能为空',
          trigger: 'blur'
        }]
      }
    }
  },
  props: ['appid'],
  methods: {
    handleSubmit: function (name) {
      this.model.app_id = this.appid
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateModule(this.model).then(async res => {
        if (res.error) {
          this.$Message.error(res.error)
        } else {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
